{
  "name": "billdeo",
  "version": "1.4.6",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "deploy": "ng build --configuration development --base-href / && cp .htaccess /var/www/billdeo-webapp-dev",
    "deploy-prod": "ng build --configuration production --base-href / && cp .htaccess /var/www/billdeo-webapp",
    "test": "ng test"
  },
  "private": true,
  "overrides": {
    "postcss": "8.5.12",
    "webpack-dev-server": "5.2.4",
    "uuid": "11.1.1"
  },
  "dependencies": {
    "@angular/animations": "^21.2.9",
    "@angular/cdk": "^21.2.7",
    "@angular/common": "^21.2.9",
    "@angular/compiler": "^21.2.9",
    "@angular/core": "^21.2.9",
    "@angular/forms": "^21.2.9",
    "@angular/material": "^21.2.7",
    "@angular/platform-browser": "^21.2.9",
    "@angular/platform-browser-dynamic": "^21.2.9",
    "@angular/router": "^21.2.9",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-free": "^6.7.2",
    "@fortawesome/free-brands-svg-icons": "^6.7.2",
    "@fortawesome/free-regular-svg-icons": "^6.7.2",
    "@fortawesome/free-solid-svg-icons": "^6.7.2",
    "@popperjs/core": "^2.11.8",
    "bootstrap": "^5.3.3",
    "chart.js": "^4.4.7",
    "html2canvas": "^1.4.1",
    "jquery": "^3.7.1",
    "jspdf": "^4.2.1",
    "moment": "^2.30.1",
    "ng2-charts": "^7.0.0",
    "ngx-pagination": "^6.0.3",
    "ngx-toastr": "^19.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.7",
    "@angular/cli": "^21.2.7",
    "@angular/compiler-cli": "^21.2.9",
    "@types/jasmine": "~5.1.0",
    "@types/jquery": "^3.5.32",
    "@types/node": "^22.10.2",
    "baseline-browser-mapping": "^2.10.19",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.9.3"
  }
}
